import { Skeleton, SkeletonBadge, SkeletonButton, SkeletonCard } from 'shared/components/ui/Skeleton';

function RowSkeleton({ withDate }: { withDate?: boolean }) {
  return (
    <div aria-hidden="true" className="flex items-center gap-4 rounded-xl border border-border/70 bg-surface p-3">
      {withDate && (
        <div className="flex w-12 flex-col items-center gap-1.5">
          <Skeleton className="h-2.5 w-7" />
          <Skeleton className="h-5 w-6" />
        </div>
      )}
      <div className="flex-1">
        <Skeleton className="h-3.5 w-32" />
        <Skeleton className="mt-2 h-3 w-24" />
      </div>
      <Skeleton className="h-4 w-12" />
    </div>
  );
}

// Espelha a aba "Meu plano": <PlanCard>, próximas sessões e opções de upgrade.
export function ClassesSkeleton() {
  return (
    <div className="mt-6 flex flex-col gap-8">
      <SkeletonCard>
        <div className="flex items-center justify-between">
          <Skeleton className="h-3 w-32" />
          <SkeletonBadge className="w-14" />
        </div>
        <Skeleton className="mt-3 h-5 w-40" />
        <Skeleton className="mt-2 h-3 w-48" />
        <Skeleton className="mt-4 h-3 w-44" />
        <Skeleton className="mt-2 h-3 w-36" />
        <div className="mt-4 flex gap-3">
          <SkeletonButton className="flex-1" />
          <SkeletonButton className="flex-1" />
        </div>
      </SkeletonCard>
      <div>
        <Skeleton className="h-3 w-32" />
        <div className="mt-3 flex flex-col gap-2">
          <RowSkeleton withDate />
          <RowSkeleton withDate />
        </div>
      </div>
      <div>
        <Skeleton className="h-3 w-20" />
        <div className="mt-3 flex flex-col gap-2">
          <RowSkeleton />
        </div>
      </div>
    </div>
  );
}
